import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, CheckCircle, Loader2 } from "lucide-react";

import logo from "../../assets/nhclogo.png";
import { getApiUrl } from "../../utils/api";

const ResetPasswordPage = () => {
    const initialState = {
        email: "",
        error: false,
        message: null,
        success: false
    };

    const [user, setUser] = useState({ ...initialState });
    const [loading, setLoading] = useState(false);

    const apiUrl = getApiUrl();

    const handleChange = (e) => {
        e.target.name === "email"
            ? setUser({ ...user, email: e.target.value })
            : setUser({ ...user });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: user.email,
                }),
            };
            const response = await fetch(
                `${apiUrl}/users/requestpassword`,
                requestOptions
            );

            if (response.ok) {
                await response
                    .json()
                    .then((data) => {
                        if (data.success) {
                            setUser({ ...user, message: data.message, success: true });
                        } else {
                            setUser({ ...user, message: data.message, success: false });
                        }
                    }
                    );
            } else {
                const data = await response.json();
                setUser({ ...user, message: data.message, success: false });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-primary-dark p-4">
            <div className="w-full max-w-sm bg-white rounded-2xl shadow-modal p-8 md:p-10">
                {/* logo */}
                <div className="flex justify-center mb-6">
                    <img src={logo} alt="National HealthClaim" className="w-56" />
                </div>

                {/* title */}
                <div className="text-center text-xs font-medium tracking-widest text-gray-600 mb-4">
                    ADVISOR PORTAL
                </div>

                <h2 className="text-center text-lg font-semibold text-gray-900 mb-6">
                    Reset or Setup password
                </h2>

                {/* success message */}
                {user.success === true && user.message !== null && (
                    <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-xl text-green-600 text-sm flex items-center gap-2">
                        <CheckCircle className="w-4 h-4 flex-shrink-0" />
                        <span>{user.message}</span>
                    </div>
                )}

                {/* error message */}
                {user.success === false && user.message !== null && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm flex items-center gap-2">
                        <AlertCircle className="w-4 h-4 flex-shrink-0" />
                        <span>{user.message}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    {/* email field */}
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Email address
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={user.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                            className="w-full p-4 border border-gray-200 rounded-xl text-base text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-all duration-200"
                        />
                    </div>

                    {/* submit button */}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-primary text-white py-4 px-6 rounded-full font-semibold text-base shadow-sm hover:bg-primary-dark active:scale-[0.98] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    >
                        {loading && <Loader2 className="w-5 h-5 animate-spin" />}
                        {loading ? "Submitting..." : "Submit"}
                    </button>
                </form>

                {/* return to login link */}
                <Link
                    to="/signin"
                    className="block mt-4 text-center text-sm text-primary hover:text-primary-dark transition-colors"
                >
                    Return to login
                </Link>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
